import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { toast } from "react-toastify";
import Loading from "../Loading";

const HelpModal = ({ show, setShow }) => {
  const [text, setText] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  async function getData(e) {
    const user = JSON.parse(localStorage.getItem("user"));

    await httpReauest(
      "GET",
      "/user/help/html",
      {},
      { "x-access-token": user?.token }
    )
      .then((res) => {
        setText(res.data?.data?.html);
      })
      .catch((data) => {
        toast.error(data?.response?.data?.message);
      });
    setLoading(false);
  }
  if (show) {
    return (
      <>
        <div
          onClick={() => setShow(false)}
          className="w-full h-full z-40 bg-black/80 fixed top-0 left-0"
        ></div>
        <div className="fixed p-5 bg-[#1E2B3B] max-w-2xl  z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-h-[80vh] overflow-y-auto rounded-[14px]">
          {loading ? (
            <Loading />
          ) : (
            <div>
              <div
                className="text-white desc_details mb-5"
                dangerouslySetInnerHTML={{ __html: text }}
              />
              <button
                onClick={() => setShow(false)}
                className="btn-brand w-full"
              >
                Okay, I understand
              </button>
            </div>
          )}
        </div>
      </>
    );
  }
};

export default HelpModal;
